import React from "react";

class InputNote extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            body: "",
        };

        this.onChangeTitleInput = this.onChangeTitleInput.bind(this);
        this.onChangeBodyInput = this.onChangeBodyInput.bind(this);
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
    }
    onChangeTitleInput(event) {
        const { value } = event.target;

        this.setState((prevState) => {
            return {
                ...prevState,
                title: value.length > 50 ? value.slice(0, 50) : value,
            };
        });
    }

    onChangeBodyInput(event) {
        this.setState((prevState) => {
            return {
                ...prevState,
                body: event.target.value,
            };
        });
    }

    onSubmitHandler(event) {
        event.preventDefault();
        this.props.addNote(this.state);
        this.setState({ title: "", body: "" });
    }

    render() {
        return (
            <>
                <form onSubmit={this.onSubmitHandler}>
                    <p className="text-sm font-semibold text-right text-secondary">
                        <span>{50 - this.state.title.length}</span> Karakter Tersisa
                    </p>

                    <input
                        className="input-title"
                        placeholder="Ini adalah judul..."
                        type="text"
                        name="search"
                        required
                        value={this.state.title}
                        onChange={this.onChangeTitleInput}
                    />

                    <textarea
                        className="input-title min-h-[175px]"
                        placeholder="Tuliskan catatanmu disini..."
                        required
                        value={this.state.body}
                        onChange={this.onChangeBodyInput}
                    ></textarea>

                    <button
                        className="block w-full py-3 pl-5 pr-1 mt-2 font-bold bg-white border rounded-xl shadow-sm dark:bg-slate-200 border-slate-300 sm:text-sm text-lg hover:bg-sky-500 hover:dark:bg-blue-800 hover:text-white"
                        type="submit"
                    >
                        Buat
                    </button>
                </form>
            </>
        );
    }
}
export default InputNote;
